import { Popover, PopoverContent, PopoverTrigger } from "design-system/atoms/Popover"
import { cn } from "design-system/utils"
import { CapabilityExecutionDetails } from "./CapabilityExecutionDetails"
import {
  getCapabilityExecutionAppearance,
  getCapabilityExecutionIcon,
  MessageCapabilityExecution,
} from "./capabilityExecutionPresentation"

type Props = { execution: MessageCapabilityExecution }

export function CapabilityExecutionMarker({ execution }: Props) {
  const KindIcon = getCapabilityExecutionIcon(execution.capabilityKind)
  const { textColorClass, borderColorClass, bgColorClass, ringColorClass } =
    getCapabilityExecutionAppearance(execution.status)

  return (
    <div
      className={cn(
        "w-full flex items-center justify-center text-xs font-medium relative group",
        textColorClass,
      )}
      id={`capability-execution-${execution.id}`}
    >
      <div className={cn("border border-b absolute w-full", borderColorClass)} />
      <Popover>
        <PopoverTrigger asChild>
          <button
            className={cn(
              "flex items-center gap-1.5 px-4 bg-background z-10 relative group-[.active-group]:text-primary-foreground duration-150 group-[.active-group]:ring-10 rounded-full cursor-pointer",
              bgColorClass,
              ringColorClass,
            )}
            type="button"
          >
            <KindIcon size={16} className="shrink-0" />
            <span className="text-xs">
              {execution.capabilityName ?? execution.capabilityIdentifier}
            </span>
          </button>
        </PopoverTrigger>
        <PopoverContent className="flex flex-col gap-3 max-w-md">
          <CapabilityExecutionDetails execution={execution} />
        </PopoverContent>
      </Popover>
    </div>
  )
}
